import { render } from "./Sessions.vue?vue&type=template&id=177389fe&bindings={\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\",\"permissions\":\"props\",\"moment\":\"options\"}"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "177389fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('177389fe')) {
    api.reload('177389fe', script)
  }
  
  module.hot.accept("./Sessions.vue?vue&type=template&id=177389fe&bindings={\"classroom\":\"props\",\"sessions\":\"props\",\"flash\":\"props\",\"permissions\":\"props\",\"moment\":\"options\"}", () => {
    api.rerender('177389fe', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Classroom/Sessions.vue"

export default script